import React from 'react';
import { useIntl } from 'react-intl';

import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFinished } from '@futrli/ui-components/components/sidebar/wizard/wizard-finished/wizard-finished';

interface UserUpdatedWizardScreenProps {
  onClose: () => void;
}

export const UserUpdatedWizardScreen = ({ onClose }: UserUpdatedWizardScreenProps) => {
  const intl = useIntl();

  return (
    <WizardScreen footerMode={FooterMode.CREATED} onCancel={onClose}>
      <WizardFinished
        text={intl.formatMessage({
          id: 'common.success_user_updated',
          defaultMessage: 'Success - user has been updated'
        })}
      />
    </WizardScreen>
  );
};
